<template>
  <div class="flex min-h-screen flex-col">
    <Header />
    <main class="relative flex flex-1 flex-col">
      <NuxtLoadingIndicator />
      <div class="flex flex-1">
        <slot />
        <ClientOnly>
          <FittingboxModal />
        </ClientOnly>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script setup lang="ts">
import { useLazyAsyncData } from '#imports'
import { useGuestCartStore } from '~/store/guestCart'
import { useGuestStore } from '~/store/guest'

const guestCartStore = useGuestCartStore()
const { guest } = useGuestStore()

useLazyAsyncData(
  'cart',
  async () => {
    if (guest?.token) {
      await guestCartStore.initCart()
    }
    return true
  },
  { server: false },
)
</script>
